module.exports = __webpack_public_path__ + "img/icon-safe6.7540cc7f.png";